import { DEFAULT_REDACT_SELECTORS, redact } from './redact';
import { log } from './logger';

const STRIP_TAGS = ['script', 'style', 'noscript', 'template', 'link', 'meta'];

export interface HtmlCapture {
  html: string;
  bytes: number;
  truncated: boolean;
}

export interface CaptureHtmlOptions {
  redactSelectors?: readonly string[];
  maxBytes: number;
}

function stripPrivate(root: Element, selectors: readonly string[]): number {
  let removed = 0;
  for (const selector of selectors) {
    let matches: Element[];
    try {
      matches = Array.from(root.querySelectorAll(selector));
    } catch {
      continue;
    }
    for (const el of matches) {
      el.remove();
      removed += 1;
    }
  }
  return removed;
}

export function captureHtml(options: CaptureHtmlOptions): HtmlCapture {
  const { redactSelectors = [], maxBytes } = options;

  const clone = document.documentElement.cloneNode(true) as HTMLElement;

  for (const el of Array.from(clone.querySelectorAll('[data-agent-sdk-root]'))) el.remove();

  for (const tag of STRIP_TAGS) {
    for (const el of Array.from(clone.querySelectorAll(tag))) el.remove();
  }

  const removed = stripPrivate(clone, [...DEFAULT_REDACT_SELECTORS, ...redactSelectors]);

  for (const input of Array.from(clone.querySelectorAll('input, textarea'))) {
    if (input.hasAttribute('value')) input.setAttribute('value', '');
  }

  const raw = redact(clone.outerHTML);
  const encoded = new TextEncoder().encode(raw);
  const truncated = encoded.length > maxBytes;
  const html = truncated ? new TextDecoder().decode(encoded.subarray(0, maxBytes)) : raw;

  log.debug(
    `html capture: ${(encoded.length / 1024).toFixed(1)} KB${truncated ? ` (truncated to ${(maxBytes / 1024).toFixed(0)} KB)` : ''}, ${removed} private subtree(s) removed`,
  );

  return { html, bytes: encoded.length, truncated };
}
